<template>
    <b-table :items="resultado"
             :fields="fields"
             striped
             small
             responsive="sm"
             :busy="configTable.load"
             show-empty
             hover
             bordered
             class="mb-0"
             head-variant="light">
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhuma TRP encontrada.</p>
        </template>
        <template v-slot:head(selecionar)="{ item }">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template v-slot:cell(selecionar)="{ item }">
            <b-form-checkbox class="coluna-resize mx-auto justify-content-center text-center" style="z-index: 0" :checked="selecteds.includes(item.codDossieTrp)" :disabled="item.situacao != 'Ativa'" @change="toggleCheck($event, item)" />
        </template>
        <template v-slot:head(1)="{ item }">
            TRP <i class="coluna-fixa filter" :class="!isEmpty(filtro.numero) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('TRP', 'mascara', '', '##########', $event)"></i>
        </template>
        <template v-slot:cell(1)="{ item }">
            <a class="link" @click="downloadAnexo(item.codDossieTrp, item.numero)">
                {{ item.numero }}
            </a>
        </template>
        <template v-slot:head(2)="{ item }">
            Processos <i class="coluna-fixa filter" :class="!isEmpty(filtro.processo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Processo', 'mascara', '', '#######-##.####.#.##.####', $event)"></i>
        </template>
        <template v-slot:cell(2)="{ item }">
            <p class="text-left" v-for="processo in item.processos">
                {{ processo }}
            </p>
        </template>
        <template v-slot:head(3)="{ item }">
            CDA(s) <i class="coluna-fixa filter" :class="!isEmpty(filtro.cda) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Cda', 'mascara', '', '##########', $event)"></i>
        </template>
        <template v-slot:cell(3)="{ item }">
            <p class="text-left" v-for="cda in item.cdas">
                {{ cda }}
            </p>
        </template>
        <template v-slot:head(4)="{ item }">
            Devedor <i class="coluna-fixa filter" :class="!isEmpty(filtro.devedor) || filtro.filtrarDevedor == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Devedor', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(4)="{ item }">
            {{ item.devedor }}
        </template>
        <template v-slot:head(5)="{ item }">
            Data de Emissão <i class="coluna-fixa filter" :class="!isEmpty(filtro.emissao) || filtro.filtrarEmissao == 5 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Data de Emissão', 'data', '', null, $event)"></i>
        </template>
        <template v-slot:cell(5)="{ item }">
            <p class="text-center">
                {{ item.dataEmissao }}
            </p>
        </template>
        <template v-slot:head(6)="{ item }">
            Usuário Responsável <i class="coluna-fixa filter" :class="!isEmpty(filtro.usuario) || filtro.filtrarUsuario == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Usuário Responsável', 'texto', '', null, $event)"></i>
        </template>
        <template v-slot:cell(6)="{ item }">
            {{ item.usuarioResponsavel }}
        </template>
        <template v-slot:head(7)="{ item }">
            Situação <i class="coluna-fixa filter" :class="!isEmpty(filtro.situacao) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação', 'checkbox', dados.listaSituacao, null, $event)"></i>
        </template>
        <template v-slot:cell(7)="{ item }">
            {{ item.situacao }}
        </template>
    </b-table>
</template>

<script>
    import formatarMixins from '../../mixins/formatarMixins';
    import axios from 'axios'
    
export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'filtro'],
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.$emit('consultar');
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            dados: {
                listaSituacao: [
                    {id: 0, nome: 'Ativo'},
                    {id: 1, nome: 'Cancelado'},
                    {id: 2, nome: 'Vencido'},
                ],
            }
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage;
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el.codDossieTrp) && (el.situacao == 'Ativa')) {
                        this.selecteds.push(el.codDossieTrp);
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el.codDossieTrp)) {
                        const index = this.selecteds.indexOf(el.codDossieTrp);
                        this.selecteds.splice(index, 1);
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked;
                this.selecteds.push(item.codDossieTrp);
            } else {
                item.checked = checked;
                const index = this.selecteds.indexOf(item.codDossieTrp);
                this.selecteds.splice(index, 1);
                this.configTable.checkedAll = false;
            }

        },
        openFilter(campo, tipo, values, mask, event) {
            this.$emit('openFilterPopup', campo, tipo, values, mask, event);
        },
        async downloadAnexo(id, numero) {
            axios.get(`${this.urlApi}/v1/cancelarTrp/downloadAnexo/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'trp_' + numero + '.pdf';
                link.click();
            })
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
